export default "__VITE_ASSET__Dlh7KiXB__"